module.exports = __webpack_public_path__ + "static/media/icon_trash.7b09569a.svg";